<template>
  <div class="change-diet-status__dropdown">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="change-diet-status__option"
      :class="`change-diet-status__option--${getDietStatusVariant(option.value)}`"
      :data-test-id="`ChangeDietStatus-option-${option.value}`"
      @click="emit('select', option.value)"
    >
      <BaseIcon
        class="change-diet-status__option-icon"
        :name="getDietStatusIcon(option.value)"
        size="14"
      />
      {{ option.label }}
    </button>
  </div>
</template>

<script lang="ts" setup>
  import BaseIcon from '@/components/BaseIcon.vue'

  import type { DietStatus } from '@/types/Diet'

  import { getDietStatusIcon, getDietStatusVariant } from '../../status'

  defineProps<{ options: { label: string; value: DietStatus }[] }>()
  const emit = defineEmits<{ select: [status: DietStatus] }>()
</script>

<style scoped>
  .change-diet-status__dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 50;
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: end;
    min-width: 100%;
    padding: 0.5rem;
    margin-top: 6px;
    background-color: var(--background-bg-primary, #fff);
    border: 1px solid var(--border-border-secondary, #e5e7eb);
    border-radius: 0.5rem;
    box-shadow:
      0 4px 6px -1px rgb(10 13 18 / 10%),
      0 2px 4px -2px rgb(10 13 18 / 6%);
  }

  .change-diet-status__option {
    display: flex;
    gap: 4px;
    align-items: center;
    width: 100%;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid;
    border-radius: 6px;
    box-shadow: 0 1px 3px hsl(0deg 0% 0% / 8%);
    transition: filter 0.15s;
  }

  .change-diet-status__option:hover {
    filter: brightness(0.97);
  }

  .change-diet-status__option-icon {
    flex-shrink: 0;
  }

  .change-diet-status__option--draft {
    color: #b54708;
    background-color: #fff9ed;
    border-color: #e4a42c;
  }

  .change-diet-status__option--draft .change-diet-status__option-icon {
    color: #e4a42c;
  }

  .change-diet-status__option--ready {
    color: #067647;
    background-color: #ebf9ed;
    border-color: #349b44;
  }

  .change-diet-status__option--ready .change-diet-status__option-icon {
    color: #349b44;
  }

  .change-diet-status__option--archived {
    color: #1a1a1a;
    background-color: #f8f8f8;
    border-color: #cacaca;
  }

  .change-diet-status__option--archived .change-diet-status__option-icon {
    color: #6b7280;
  }
</style>
